import React from 'react';
import { PAYPAL_THEME, ThemeWrapper } from 'pp-react-v5';

function withTheme(WrappedComponent, theme = 'v2') {
  return (props) => {
    return (
      <ThemeWrapper theme={PAYPAL_THEME}>
        <WrappedComponent {...props} />
      </ThemeWrapper>
    );
  };
}

export default withTheme;
